import { Icon, IconProps } from "@chakra-ui/icon";

const InfoIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.3">
        <rect
          x="6"
          y="6"
          width="26"
          height="26"
          rx="13"
          stroke="#1B58F5"
          strokeWidth="2"
        />
      </g>
      <g opacity="0.1">
        <rect
          x="1"
          y="1"
          width="36"
          height="36"
          rx="18"
          stroke="#1B58F5"
          strokeWidth="2"
        />
      </g>
      <g clipPath="url(#clip0_4137_29891)">
        <path
          d="M19 22.3334V19.0001M19 15.6667H19.0083M27.3333 19.0001C27.3333 23.6025 23.6023 27.3334 19 27.3334C14.3976 27.3334 10.6666 23.6025 10.6666 19.0001C10.6666 14.3977 14.3976 10.6667 19 10.6667C23.6023 10.6667 27.3333 14.3977 27.3333 19.0001Z"
          stroke="#1B58F5"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4137_29891">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(9 9)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};

export default InfoIcon;
